/* eslint-disable no-param-reassign */

import {
  TbBuilding,
  TbBell,
  TbUsers,
  TbMapPin,
  TbCoinEuro,
  TbBolt,
  TbStar,
  TbBan,
} from 'react-icons/tb';

import { createLocale } from 'locales';

import type { RouteGroup } from 'pages/organization/OrganisationSettingsPage/components/organisation-side-bar';

const globalLocalize = createLocale('global');

const getSidebarLinks = (selectedLink?: {
  groupName: string;
  name: string;
}): RouteGroup[] => {
  const sideBar: RouteGroup[] = [
    {
      label: globalLocalize('account'),
      name: 'account',
      routes: [
        {
          icon: TbBuilding,
          id: 1,
          isSelected: false,
          label: globalLocalize('details'),
          name: 'details',
          src: '/organisation/settings/organisations/',
        },
        {
          icon: TbBell,
          id: 3,
          isSelected: false,
          label: globalLocalize('notifications'),
          name: 'notifications',
          src: '/organisation/settings/notifications/',
        },
      ],
    },
    {
      label: globalLocalize('organisation'),
      name: 'organisation',
      routes: [
        {
          icon: TbBuilding,
          id: 1,
          isSelected: false,
          label: globalLocalize('details'),
          name: 'details',
          src: '/organisation/settings/organisations/',
        },
        {
          icon: TbUsers,
          id: 2,
          isSelected: false,
          label: globalLocalize('users'),
          name: 'users',
          src: '/organisation/settings/users/',
        },
        {
          icon: TbMapPin,
          id: 3,
          isSelected: false,
          label: globalLocalize('locations'),
          name: 'locations',
          src: '/organisation/settings/locations/',
        },
        {
          icon: 'custuserbook',
          id: 4,
          isSelected: false,
          label: globalLocalize('planners'),
          name: 'planners',
          src: '/organisation/planner/',
        },
        {
          icon: TbCoinEuro,
          id: 5,
          isSelected: false,
          label: globalLocalize('hourlyRates'),
          name: 'hourlyRates',
          src: '/organisation/settings/rates/',
        },
        {
          icon: TbBolt,
          id: 6,
          isSelected: false,
          label: globalLocalize('integrations'),
          name: 'integrations',
          src: '/organisation/settings/integrations/',
        },
      ],
    },
    {
      label: globalLocalize('freelancers'),
      name: 'freelancers',
      routes: [
        {
          icon: TbStar,
          id: 1,
          isSelected: false,
          label: globalLocalize('favorites'),
          name: 'favorites',
          src: '/organisation/settings/favorites/',
        },
        {
          icon: TbBan,
          id: 2,
          isSelected: false,
          label: globalLocalize('blocked'),
          name: 'blocked',
          src: '/organisation/settings/blocked/',
        },
      ],
    },
  ];

  if (selectedLink) {
    sideBar.forEach((group) => {
      group.routes.forEach((route) => {
        if (
          route.name === selectedLink.name &&
          group.name === selectedLink.groupName
        ) {
          route.isSelected = true;
        } else {
          route.isSelected = false;
        }
      });
    });
  }

  return sideBar;
};

export default getSidebarLinks;
